module.exports = __webpack_public_path__ + "static/media/4.28d2aef9.svg";